// This file instantiates one Bugsnag client for the entire application

// Components and modules that want to send handled errors can import the
// exported client to send handled errors

// Components can get access to the React <ErrorBoundary/> by calling
//
//    const ErrorBoundary = bugsnagClient.getPlugin('react')
//

import bugsnag from '@bugsnag/js'
import bugsnagReact from '@bugsnag/plugin-react'
import React from 'react'

let bugsnagClient;
if (process.env.NODE_ENV === 'development') {
    bugsnagClient = '';
}
else {
    bugsnagClient = bugsnag('8afa0ce05d1d8672834e92d7d8d1176e')
        .use(bugsnagReact, React)
}

export default bugsnagClient


// WEBPACK FOOTER //
// ./src/lib/bugsnag.js